'use client'
import useWidgetsRequest from './useWidgetsRequest'

export { useWidgetsRequest }
